import { combineReducers } from 'redux';
import languageReducer from './languageReducer';
import authReducer from './authReducer';
import assetTypeReducer from '../../asset-types/redux/reducers/AssetTypesReducer';
import globalPeriodReducer from '../../selection-criteria/period/redux/reducers/GlobalPeriodSelectionReducers';

export default combineReducers({
  i18n: languageReducer,
  auth: authReducer,
  assetType: assetTypeReducer,
  globalPeriod: globalPeriodReducer,
});
